module.exports = __webpack_public_path__ + "img/cerrar-sesion-white.f199aede.svg";